import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import App from './App';

// Custom theme with your color scheme
const theme = extendTheme({
  colors: {
    brand: {
      teal: '#69c7bc',
      blue: '#5BC0EB',
      yellow: '#FFC107',
      lightBlue: '#87CEEB',
      dark: '#2d3436',
      gray: '#636e72',
    },
  },
  fonts: {
    heading: '"Poppins", sans-serif',
    body: '"Poppins", sans-serif',
  },
  styles: {
    global: {
      body: {
        bg: 'white',
        color: 'gray.800',
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);
